import axios from '../utils/auth';

const savePost = (inputs) => {
    let currentLang = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : 'en';

    const formData = new FormData();
    for ( var key in inputs ) {
        formData.append(key, inputs[key]);
    }
    formData.append('currentLang', currentLang);
    return axios().post("post/create", formData);
}

const postList = (inputs) => {
    return axios().post("post/list", inputs);
}
const postDetails = (id) => {
    return axios().get("post/details/" + id);
}
const postPublic = (params) => {
    return axios().get("post/view/" + params.id + "?activeLang=" + params.currentLang);
}
const postDelete = (id) => {
    return axios().get("post/delete/" + id);
}
const allPosts = (inputs) => {
    return axios().post("post/all", inputs);
}

const postService = {
    savePost,
    postList,
    postDetails,
    postDelete,
    allPosts,
    postPublic
};

export default postService;
